export interface DynamicScript {
  id: string;
  src: string;
  async: boolean;
  globalCallback?: string;
}

export const LOCALLOGIC_SCRIPT: DynamicScript = {
  id: 'localLogicScript',
  src: 'https://cdn.locallogic.co/sdk/?token=b670557293fa0fb47e0635ca613dcde990d1045611088d007412b88c8714da874a4847cc6c9c4a0e&callback=initLocallogic',
  async: true
};

export const CLIPBOARD_SCRIPT: DynamicScript = {
  id: 'clipboardScript',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/1.7.1/clipboard.min.js',
  async: true
};

export const SWIPER_SCRIPT: DynamicScript = {
  id: 'swiperScript',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.2.6/js/swiper.min.js',
  async: true
};

export const RECAPTCHA_SCRIPT: DynamicScript = {
  id: 'recaptchaScript',
  src: 'https://www.google.com/recaptcha/api.js?render=explicit&onload=grecaptchaOnload',
  async: true,
  globalCallback: 'grecaptchaOnload'
};

export const CHART_SCRIPT: DynamicScript = {
  id: 'chartScript',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.2/Chart.min.js',
  async: true,
};
